/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_RETURN_FILLING,
  SET_CLEAR_GRAPH
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  returnFilling: []
};

/* eslint-disable default-case, no-param-reassign */
const ReturnFillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_RETURN_FILLING:
      return {
        ...state,
        returnFilling: action.returnFilling
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        returnFilling: []
      };
    default:
      return state;
  }
};

export default ReturnFillingReducer;
